import { jsx } from 'react/jsx-runtime';
import { cssVar } from '@fabric-app/ui/theme/variables';
import { Flex } from '@fabric-app/ui/components/Flex';
import { motion } from 'framer-motion';
import { styled, css } from 'styled-components';
import { IconSidePanelChevronRight } from '@fabric-app/icons/svg';
import { mediaHover } from '@fabric-app/ui/constants/styled-utils';
import { Modal } from '@fabric-app/ui/components/Modal/Modal';

const ExtraPanelSidebarRoot = styled(motion.div).attrs((p) => {
  return {
    ...p,
    "data-assistant-fullscreen": p.isFullscreen
  };
}).withConfig({
  displayName: "Sidebar__ExtraPanelSidebarRoot",
  componentId: "sc-c4e0ab81-0"
})([
  `min-width:360px;max-width:360px;width:100%;height:100%;flex-shrink:0;background:`,
  `;display:flex;flex-direction:column;border-radius:20px;`,
  ``
], cssVar["color-bg-assistant"], ({ isFullscreen }) => isFullscreen && css([
  `position:fixed;right:0;left:0;top:0 !important;width:100%;height:100% !important;max-width:none;border-radius:0;z-index:125;`
]));
const ExtraPanelSidebarHeader = styled(Flex).attrs((p) => {
  return {
    alignItems: "center",
    flexGrow: 0,
    ...p
  };
}).withConfig({
  displayName: "Sidebar__ExtraPanelSidebarHeader",
  componentId: "sc-c4e0ab81-1"
})([
  `padding:0.75rem;gap:0.453rem;flex-shrink:0;border-bottom:1px solid rgba(`,
  `,0.1);`
], cssVar["color-bg-contrast-reverse-rgb"]);
const ExtraPanelSidebarContent = styled(Flex).attrs((p) => {
  return {
    direction: "column",
    ...p
  };
}).withConfig({
  displayName: "Sidebar__ExtraPanelSidebarContent",
  componentId: "sc-c4e0ab81-2"
})([
  `border-radius:20px;overflow:hidden;height:100%;`
]);
const ExtraPanelSidebarButton = styled.button.withConfig({
  displayName: "Sidebar__ExtraPanelSidebarButton",
  componentId: "sc-c4e0ab81-3"
})([
  `display:flex;align-items:center;justify-content:center;height:30px;padding:0 0.375rem;background:rgba(`,
  `,0.04);border-radius:10px;outline:none;border:none;cursor:pointer;font-size:13px;color:`,
  `;`,
  `{&:hover{background:rgba(`,
  `,0.08);}}[data-assistant-fullscreen='true'] &{height:40px;min-width:40px;padding:0 0.75rem;}`
], cssVar["color-bg-contrast-reverse-rgb"], cssVar["color-text-primary"], mediaHover, cssVar["color-bg-contrast-reverse-rgb"]);
const ExtraPanelSidebarCloseButton = styled(ExtraPanelSidebarButton).attrs((p) => ({
  ...p,
  children: /* @__PURE__ */ jsx(IconSidePanelChevronRight, {})
})).withConfig({
  displayName: "Sidebar__ExtraPanelSidebarCloseButton",
  componentId: "sc-c4e0ab81-4"
})([
  ``
]);
const FullScreenIconButton = styled(Modal.IconButton).withConfig({
  displayName: "Sidebar__FullScreenIconButton",
  componentId: "sc-c4e0ab81-5"
})([
  `background:rgba(`,
  `,0.06);`
], cssVar["color-bg-primary-reverse-rgb"]);
const FullScreenButtonsContainer = styled(Flex).withConfig({
  displayName: "Sidebar__FullScreenButtonsContainer",
  componentId: "sc-c4e0ab81-6"
})([
  `gap:8px;margin-left:auto;`
]);
const FullScreenTitle = styled.div.withConfig({
  displayName: "Sidebar__FullScreenTitle",
  componentId: "sc-c4e0ab81-7"
})([
  `font-size:14px;color:`,
  `;padding:0 6px;`
], cssVar["color-text-primary"]);
const ExtraPanelSidebar = {
  Root: ExtraPanelSidebarRoot,
  Header: ExtraPanelSidebarHeader,
  Content: ExtraPanelSidebarContent,
  Button: ExtraPanelSidebarButton,
  CloseButton: ExtraPanelSidebarCloseButton,
  FullScreenIconButton,
  FullScreenButtonsContainer,
  FullScreenTitle
};

export { ExtraPanelSidebar, ExtraPanelSidebarContent, ExtraPanelSidebarHeader, ExtraPanelSidebarRoot };
//# sourceMappingURL=Sidebar.js.map
